module.exports = __webpack_public_path__ + "static/media/homeTitle6.1922d6cd.png";